!(function (e, t) {
  if ('object' == typeof exports && 'object' == typeof module)
    module.exports = t(
      require('react'),
      require('prop-types'),
      require('lodash'),
      require('react-dom'),
      require('framer-motion'),
      require('styled-components'),
      require('styled-tools')
    );
  else if ('function' == typeof define && define.amd)
    define([
      'react',
      'prop-types',
      'lodash',
      'react-dom',
      'framer-motion',
      'styled-components',
      'styled-tools',
    ], t);
  else {
    var n =
      'object' == typeof exports
        ? t(
            require('react'),
            require('prop-types'),
            require('lodash'),
            require('react-dom'),
            require('framer-motion'),
            require('styled-components'),
            require('styled-tools')
          )
        : t(
            e.react,
            e['prop-types'],
            e.lodash,
            e['react-dom'],
            e['framer-motion'],
            e['styled-components'],
            e['styled-tools']
          );
    for (var r in n) ('object' == typeof exports ? exports : e)[r] = n[r];
  }
})(self, function (e, t, n, r, o, i, a) {
  return (function () {
    'use strict';
    var c = {
        641: function (e, t, n) {
          n.r(t),
            n.d(t, {
              Tooltip: function () {
                return we;
              },
              default: function () {
                return me;
              },
            });
          var r = n(297),
            o = n.n(r),
            i = n(229),
            a = n.n(i),
            c = n(804),
            s = n.n(c),
            l = n(268),
            u = n(762);
          function f(e, t) {
            return (
              (function (e) {
                if (Array.isArray(e)) return e;
              })(e) ||
              (function (e, t) {
                if (
                  'undefined' != typeof Symbol &&
                  Symbol.iterator in Object(e)
                ) {
                  var n = [],
                    r = !0,
                    o = !1,
                    i = void 0;
                  try {
                    for (
                      var a, c = e[Symbol.iterator]();
                      !(r = (a = c.next()).done) &&
                      (n.push(a.value), !t || n.length !== t);
                      r = !0
                    );
                  } catch (e) {
                    (o = !0), (i = e);
                  } finally {
                    try {
                      r || null == c.return || c.return();
                    } finally {
                      if (o) throw i;
                    }
                  }
                  return n;
                }
              })(e, t) ||
              (function (e, t) {
                if (e) {
                  if ('string' == typeof e) return p(e, t);
                  var n = Object.prototype.toString.call(e).slice(8, -1);
                  return (
                    'Object' === n && e.constructor && (n = e.constructor.name),
                    'Map' === n || 'Set' === n
                      ? Array.from(e)
                      : 'Arguments' === n ||
                        /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
                      ? p(e, t)
                      : void 0
                  );
                }
              })(e, t) ||
              (function () {
                throw new TypeError(
                  'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
                );
              })()
            );
          }
          function p(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
            return r;
          }
          var d = function (e, t, n) {
              var r = f(t, 3),
                o = r[0],
                i = r[1],
                a = r[2],
                c = f(n, 3),
                l = c[0],
                u = c[1],
                p = c[2];
              return i > a && e.toLowerCase().includes(o)
                ? e.replace(o, l).replace(s().upperFirst(o), s().upperFirst(l))
                : u < p && e.toLowerCase().includes(l)
                ? e.replace(l, o).replace(s().upperFirst(l), s().upperFirst(o))
                : e;
            },
            m = n(914),
            h = n.n(m),
            g = n(849),
            w = h()(u.motion.div).withConfig({
              displayName: 'styled__Container',
              componentId: 'idui-popover__sc-1mloye0-0',
            })(
              [
                'position:absolute;box-shadow:0 0.4rem 0.8rem -0.4rem rgba(0,0,0,0.11),0 0.8rem 1.6rem 0 rgba(0,0,0,0.09),0 0.9rem 1.5rem 0.9rem rgba(0,0,0,0.05);z-index:',
                ';background-color:#ffffff;border-radius:0.3rem;cursor:default;padding:1.2rem 1.6rem;width:',
                ';height:',
                ';',
                ';',
                ';',
                '',
              ],
              (0, g.prop)('zIndex', 1e3),
              (0, g.prop)('width'),
              (0, g.prop)('height'),
              (0, g.prop)('positionStyles'),
              (0, g.ifProp)(
                'withArrow',
                (0, m.css)(
                  [
                    "&:before{content:'';position:absolute;border:",
                    'px solid #ffffff;border-right-color:transparent;border-top-color:transparent;box-shadow:-0.2rem 0.2rem 0.7rem rgba(0,0,0,0.07);',
                    ';}',
                  ],
                  (0, g.withProp)('arrowSize', function (e) {
                    return e / 2;
                  }),
                  (0, g.prop)('arrowStyles')
                )
              ),
              (0, g.ifProp)(
                'isCheckingContentDimensions',
                (0, m.css)(['left:-99.9rem;top:-99.9rem;'])
              )
            ),
            v = h().div.withConfig({
              displayName: 'styled__Inner',
              componentId: 'idui-popover__sc-1mloye0-1',
            })(
              ['', ' ', ' height:100%;overflow:auto;'],
              (0, g.ifProp)(
                'maxHeight',
                (0, m.css)(
                  ['max-height:', '!important;'],
                  (0, g.prop)('maxHeight')
                )
              ),
              (0, g.ifProp)(
                'maxWidth',
                (0, m.css)(
                  ['max-width:', '!important;'],
                  (0, g.prop)('maxWidth')
                )
              )
            );
          function y(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function b(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? y(Object(n), !0).forEach(function (t) {
                    x(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : y(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function x(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          var O = function (e) {
              var t = e.withArrow,
                n = e.arrowSize;
              return e.spaceBetweenPopoverAndTarget + (t ? n / 2 : 0);
            },
            P = {
              top: function (e, t) {
                var n = e.width,
                  r = e.top,
                  o = e.left,
                  i = t.offset,
                  a = t.withArrow,
                  c = t.animation,
                  s = t.openingAnimationTranslateDistance,
                  l = t.closingAnimationTranslateDistance,
                  u = t.minSpaceBetweenPopoverAndContainer,
                  f = t.spaceBetweenPopoverAndTarget,
                  p = t.arrowSize,
                  d = t.fitMaxHeightToBounds,
                  h = t.fitMaxWidthToBounds,
                  g = t.verticalPadding,
                  w = t.horizontalPadding,
                  y = t.avoidOverflowBounds,
                  x = t.contentHeight,
                  P = t.contentWidth,
                  A = t.containerWidth,
                  T =
                    i[1] -
                    O({
                      withArrow: a,
                      arrowSize: p,
                      spaceBetweenPopoverAndTarget: f,
                    }),
                  S = d ? r + T - u : x,
                  B = h ? A - 2 * u : P;
                return {
                  style: (0, m.css)(
                    [
                      'top:',
                      'px;left:',
                      'px;',
                      '{max-height:',
                      'px;max-width:',
                      'px;min-width:',
                      'px;}',
                    ],
                    d || !y ? r + T : Math.max(r + T, x + u),
                    o + n / 2 + i[0],
                    v,
                    S - g,
                    B - w,
                    Math.min(B, P) - w
                  ),
                  initial: b(
                    b({}, c.initial),
                    {},
                    { y: '-'.concat(100 - s, '%'), x: '-50%' }
                  ),
                  animate: b(b({}, c.animate), {}, { y: '-100%', x: '-50%' }),
                  exit: b(
                    b({}, c.exit),
                    {},
                    { y: '-'.concat(100 - l, '%'), x: '-50%' }
                  ),
                };
              },
              topRight: function (e, t) {
                var n = e.top,
                  r = e.right,
                  o = t.offset,
                  i = t.withArrow,
                  a = t.animation,
                  c = t.openingAnimationTranslateDistance,
                  s = t.closingAnimationTranslateDistance,
                  l = t.minSpaceBetweenPopoverAndContainer,
                  u = t.spaceBetweenPopoverAndTarget,
                  f = t.arrowSize,
                  p = t.fitMaxHeightToBounds,
                  d = t.fitMaxWidthToBounds,
                  h = t.verticalPadding,
                  g = t.horizontalPadding,
                  w = t.avoidOverflowBounds,
                  y = t.contentHeight,
                  x = t.contentWidth,
                  P =
                    o[1] -
                    O({
                      withArrow: i,
                      arrowSize: f,
                      spaceBetweenPopoverAndTarget: u,
                    }),
                  A = p ? n + P - l : y,
                  T = d ? r + o[0] - l : x;
                return {
                  style: (0, m.css)(
                    [
                      'top:',
                      'px;left:',
                      'px;',
                      '{max-height:',
                      'px;max-width:',
                      'px;min-width:',
                      'px;}',
                    ],
                    p || !w ? n + P : Math.max(n + P, y + l),
                    d || !w ? r + o[0] : Math.max(r + o[0], x + l),
                    v,
                    A - h,
                    T - g,
                    Math.min(T, x) - g
                  ),
                  initial: b(
                    b({}, a.initial),
                    {},
                    { x: '-'.concat(100 - c, '%'), y: '-100%' }
                  ),
                  animate: b(b({}, a.animate), {}, { x: '-100%', y: '-100%' }),
                  exit: b(
                    b({}, a.exit),
                    {},
                    { x: '-'.concat(100 - s, '%'), y: '-100%' }
                  ),
                };
              },
              topLeft: function (e, t) {
                var n = e.top,
                  r = e.left,
                  o = t.offset,
                  i = t.withArrow,
                  a = t.animation,
                  c = t.openingAnimationTranslateDistance,
                  s = t.closingAnimationTranslateDistance,
                  l = t.minSpaceBetweenPopoverAndContainer,
                  u = t.spaceBetweenPopoverAndTarget,
                  f = t.arrowSize,
                  p = t.fitMaxHeightToBounds,
                  d = t.fitMaxWidthToBounds,
                  h = t.verticalPadding,
                  g = t.horizontalPadding,
                  w = t.avoidOverflowBounds,
                  y = t.contentHeight,
                  x = t.contentWidth,
                  P = t.containerWidth,
                  A =
                    o[1] -
                    O({
                      withArrow: i,
                      arrowSize: f,
                      spaceBetweenPopoverAndTarget: u,
                    }),
                  T = p ? n + A - l : y,
                  S = d ? P - (r + o[0] + l) : x;
                return {
                  style: (0, m.css)(
                    [
                      'top:',
                      'px;left:',
                      'px;',
                      '{max-height:',
                      'px;max-width:',
                      'px;}',
                    ],
                    p || !w ? n + A : Math.max(n + A, y + l),
                    d || !w ? r + o[0] : Math.min(r + o[0], P - x - l),
                    v,
                    T - h,
                    S - g
                  ),
                  initial: b(
                    b({}, a.initial),
                    {},
                    { x: '-'.concat(c, '%'), y: '-100%' }
                  ),
                  animate: b(b({}, a.animate), {}, { x: 0, y: '-100%' }),
                  exit: b(
                    b({}, a.exit),
                    {},
                    { x: '-'.concat(s, '%'), y: '-100%' }
                  ),
                };
              },
              bottom: function (e, t) {
                var n = e.bottom,
                  r = e.left,
                  o = e.width,
                  i = t.offset,
                  a = t.withArrow,
                  c = t.animation,
                  s = t.openingAnimationTranslateDistance,
                  l = t.closingAnimationTranslateDistance,
                  u = t.minSpaceBetweenPopoverAndContainer,
                  f = t.spaceBetweenPopoverAndTarget,
                  p = t.arrowSize,
                  d = t.fitMaxHeightToBounds,
                  h = t.fitMaxWidthToBounds,
                  g = t.verticalPadding,
                  w = t.horizontalPadding,
                  y = t.avoidOverflowBounds,
                  x = t.contentHeight,
                  P = t.contentWidth,
                  A = t.containerHeight,
                  T = t.containerWidth,
                  S =
                    i[1] +
                    O({
                      withArrow: a,
                      arrowSize: p,
                      spaceBetweenPopoverAndTarget: f,
                    }),
                  B = d ? A - (n + S + u) : x,
                  C = h ? T - 2 * u : P;
                return {
                  style: (0, m.css)(
                    [
                      'top:',
                      'px;left:',
                      'px;',
                      '{max-height:',
                      'px;max-width:',
                      'px;min-width:',
                      'px;}',
                    ],
                    d || !y ? n + S : Math.min(n + S, A - x - u),
                    r + o / 2 + i[0],
                    v,
                    B - g,
                    C - w,
                    Math.min(C, P) - w
                  ),
                  initial: b(
                    b({}, c.initial),
                    {},
                    { y: '-'.concat(s, '%'), x: '-50%' }
                  ),
                  animate: b(b({}, c.animate), {}, { y: 0, x: '-50%' }),
                  exit: b(
                    b({}, c.exit),
                    {},
                    { y: '-'.concat(l, '%'), x: '-50%' }
                  ),
                };
              },
              bottomRight: function (e, t) {
                var n = e.bottom,
                  r = e.right,
                  o = t.offset,
                  i = t.withArrow,
                  a = t.animation,
                  c = t.openingAnimationTranslateDistance,
                  s = t.closingAnimationTranslateDistance,
                  l = t.minSpaceBetweenPopoverAndContainer,
                  u = t.spaceBetweenPopoverAndTarget,
                  f = t.arrowSize,
                  p = t.fitMaxHeightToBounds,
                  d = t.fitMaxWidthToBounds,
                  h = t.verticalPadding,
                  g = t.horizontalPadding,
                  w = t.avoidOverflowBounds,
                  y = t.contentHeight,
                  x = t.contentWidth,
                  P = t.containerHeight,
                  A =
                    o[1] +
                    O({
                      withArrow: i,
                      arrowSize: f,
                      spaceBetweenPopoverAndTarget: u,
                    }),
                  T = p ? P - (n + A + l) : y,
                  S = d ? r + o[0] - l : x;
                return {
                  style: (0, m.css)(
                    [
                      'top:',
                      'px;left:',
                      'px;',
                      '{max-height:',
                      'px;max-width:',
                      'px;min-width:',
                      'px;}',
                    ],
                    p || !w ? n + A : Math.min(n + A, P - y - l),
                    d || !w ? r + o[0] : Math.max(r + o[0], x + l),
                    v,
                    T - h,
                    S - g,
                    Math.min(S, x) - g
                  ),
                  initial: b(
                    b({}, a.initial),
                    {},
                    { x: '-'.concat(100 - c, '%') }
                  ),
                  animate: b(b({}, a.animate), {}, { x: '-100%' }),
                  exit: b(b({}, a.exit), {}, { x: '-'.concat(100 - s, '%') }),
                };
              },
              bottomLeft: function (e, t) {
                var n = e.bottom,
                  r = e.left,
                  o = t.offset,
                  i = t.withArrow,
                  a = t.animation,
                  c = t.openingAnimationTranslateDistance,
                  s = t.closingAnimationTranslateDistance,
                  l = t.minSpaceBetweenPopoverAndContainer,
                  u = t.spaceBetweenPopoverAndTarget,
                  f = t.arrowSize,
                  p = t.fitMaxHeightToBounds,
                  d = t.fitMaxWidthToBounds,
                  h = t.verticalPadding,
                  g = t.horizontalPadding,
                  w = t.avoidOverflowBounds,
                  y = t.contentHeight,
                  x = t.contentWidth,
                  P = t.containerHeight,
                  A = t.containerWidth,
                  T =
                    o[1] +
                    O({
                      withArrow: i,
                      arrowSize: f,
                      spaceBetweenPopoverAndTarget: u,
                    }),
                  S = p ? P - (n + T + l) : y,
                  B = d ? A - (r + o[0] + l) : x;
                return {
                  style: (0, m.css)(
                    [
                      'top:',
                      'px;left:',
                      'px;',
                      '{max-height:',
                      'px;max-width:',
                      'px;}',
                    ],
                    p || !w ? n + T : Math.min(n + T, P - y - l),
                    d || !w ? r + o[0] : Math.min(r + o[0], A - x - l),
                    v,
                    S - h,
                    B - g
                  ),
                  initial: b(b({}, a.initial), {}, { x: '-'.concat(c, '%') }),
                  animate: b(b({}, a.animate), {}, { x: 0 }),
                  exit: b(b({}, a.exit), {}, { x: '-'.concat(s, '%') }),
                };
              },
              left: function (e, t) {
                var n = e.height,
                  r = e.top,
                  o = e.left,
                  i = t.offset,
                  a = t.withArrow,
                  c = t.animation,
                  s = t.openingAnimationTranslateDistance,
                  l = t.closingAnimationTranslateDistance,
                  u = t.minSpaceBetweenPopoverAndContainer,
                  f = t.spaceBetweenPopoverAndTarget,
                  p = t.arrowSize,
                  d = t.fitMaxHeightToBounds,
                  h = t.fitMaxWidthToBounds,
                  g = t.verticalPadding,
                  w = t.horizontalPadding,
                  y = t.avoidOverflowBounds,
                  x = t.contentHeight,
                  P = t.contentWidth,
                  A = t.containerHeight,
                  T = t.containerWidth,
                  S =
                    i[0] -
                    O({
                      withArrow: a,
                      arrowSize: p,
                      spaceBetweenPopoverAndTarget: f,
                    }),
                  B = d ? A - 2 * u : x,
                  C = h ? o + S - u : P;
                return {
                  style: (0, m.css)(
                    [
                      'left:',
                      'px;top:',
                      'px;',
                      '{max-height:',
                      'px;max-width:',
                      'px;min-width:',
                      'px;}',
                    ],
                    h || !y ? o + S : o + S > T - P - u ? u + P : o + S,
                    r + n / 2 + i[1],
                    v,
                    B - g,
                    C - w,
                    Math.min(C, P) - w
                  ),
                  initial: b(
                    b({}, c.initial),
                    {},
                    { x: '-'.concat(100 - s, '%'), y: '-50%' }
                  ),
                  animate: b(b({}, c.animate), {}, { x: '-100%', y: '-50%' }),
                  exit: b(
                    b({}, c.exit),
                    {},
                    { x: '-'.concat(100 - l, '%'), y: '-50%' }
                  ),
                };
              },
              leftBottom: function (e, t) {
                var n = e.bottom,
                  r = e.left,
                  o = t.offset,
                  i = t.withArrow,
                  a = t.animation,
                  c = t.openingAnimationTranslateDistance,
                  s = t.closingAnimationTranslateDistance,
                  l = t.minSpaceBetweenPopoverAndContainer,
                  u = t.spaceBetweenPopoverAndTarget,
                  f = t.arrowSize,
                  p = t.fitMaxHeightToBounds,
                  d = t.fitMaxWidthToBounds,
                  h = t.verticalPadding,
                  g = t.horizontalPadding,
                  w = t.avoidOverflowBounds,
                  y = t.contentHeight,
                  x = t.contentWidth,
                  P = t.containerWidth,
                  A =
                    o[0] -
                    O({
                      withArrow: i,
                      arrowSize: f,
                      spaceBetweenPopoverAndTarget: u,
                    }),
                  T = p ? n + o[1] - l : y,
                  S = d ? r + A - l : x;
                return {
                  style: (0, m.css)(
                    [
                      'left:',
                      'px;top:',
                      'px;',
                      '{max-height:',
                      'px;max-width:',
                      'px;min-width:',
                      'px;}',
                    ],
                    d || !w ? r + A : r + A > P - x - l ? l + x : r + A,
                    p || !w ? n + o[1] : Math.max(n + o[1], y + l),
                    v,
                    T - h,
                    S - g,
                    Math.min(S, x) - g
                  ),
                  initial: b(
                    b({}, a.initial),
                    {},
                    { x: '-'.concat(100 - c, '%'), y: '-100%' }
                  ),
                  animate: b(b({}, a.animate), {}, { x: '-100%', y: '-100%' }),
                  exit: b(
                    b({}, a.exit),
                    {},
                    { x: '-'.concat(100 - s, '%'), y: '-100%' }
                  ),
                };
              },
              leftTop: function (e, t) {
                var n = e.top,
                  r = e.left,
                  o = t.offset,
                  i = t.withArrow,
                  a = t.animation,
                  c = t.openingAnimationTranslateDistance,
                  s = t.closingAnimationTranslateDistance,
                  l = t.minSpaceBetweenPopoverAndContainer,
                  u = t.spaceBetweenPopoverAndTarget,
                  f = t.arrowSize,
                  p = t.fitMaxHeightToBounds,
                  d = t.fitMaxWidthToBounds,
                  h = t.verticalPadding,
                  g = t.horizontalPadding,
                  w = t.avoidOverflowBounds,
                  y = t.contentHeight,
                  x = t.contentWidth,
                  P = t.containerHeight,
                  A = t.containerWidth,
                  T =
                    o[0] -
                    O({
                      withArrow: i,
                      arrowSize: f,
                      spaceBetweenPopoverAndTarget: u,
                    }),
                  S = p ? P - (l + n + o[1]) : y,
                  B = d ? r + T - l : x;
                return {
                  style: (0, m.css)(
                    [
                      'left:',
                      'px;top:',
                      'px;',
                      '{max-height:',
                      'px;max-width:',
                      'px;min-width:',
                      'px;}',
                    ],
                    d || !w ? r + T : r + T > A - x - l ? l + x : r + T,
                    p || !w ? n + o[1] : Math.min(n + o[1], P - y - l),
                    v,
                    S - h,
                    B - g,
                    Math.min(B, x) - g
                  ),
                  initial: b(
                    b({}, a.initial),
                    {},
                    { x: '-'.concat(100 - c, '%') }
                  ),
                  animate: b(b({}, a.animate), {}, { x: '-100%' }),
                  exit: b(b({}, a.exit), {}, { x: '-'.concat(100 - s, '%') }),
                };
              },
              right: function (e, t) {
                var n = e.height,
                  r = e.top,
                  o = e.right,
                  i = t.offset,
                  a = t.withArrow,
                  c = t.animation,
                  s = t.openingAnimationTranslateDistance,
                  l = t.closingAnimationTranslateDistance,
                  u = t.minSpaceBetweenPopoverAndContainer,
                  f = t.spaceBetweenPopoverAndTarget,
                  p = t.arrowSize,
                  d = t.fitMaxHeightToBounds,
                  h = t.fitMaxWidthToBounds,
                  g = t.verticalPadding,
                  w = t.horizontalPadding,
                  y = t.avoidOverflowBounds,
                  x = t.contentHeight,
                  P = t.contentWidth,
                  A = t.containerHeight,
                  T = t.containerWidth,
                  S =
                    i[0] +
                    O({
                      withArrow: a,
                      arrowSize: p,
                      spaceBetweenPopoverAndTarget: f,
                    }),
                  B = d ? A - 2 * u : x,
                  C = h ? T - o - S - u : P;
                return {
                  style: (0, m.css)(
                    [
                      'left:',
                      'px;top:',
                      'px;',
                      '{max-height:',
                      'px;max-width:',
                      'px;}',
                    ],
                    h || !y ? o + S : Math.min(o + S, T - P - u),
                    r + n / 2 + i[1],
                    v,
                    B - g,
                    C - w
                  ),
                  initial: b(
                    b({}, c.initial),
                    {},
                    { x: '-'.concat(s, '%'), y: '-50%' }
                  ),
                  animate: b(b({}, c.animate), {}, { x: 0, y: '-50%' }),
                  exit: b(
                    b({}, c.exit),
                    {},
                    { x: '-'.concat(l, '%'), y: '-50%' }
                  ),
                };
              },
              rightBottom: function (e, t) {
                var n = e.bottom,
                  r = e.right,
                  o = t.offset,
                  i = t.withArrow,
                  a = t.animation,
                  c = t.openingAnimationTranslateDistance,
                  s = t.closingAnimationTranslateDistance,
                  l = t.minSpaceBetweenPopoverAndContainer,
                  u = t.spaceBetweenPopoverAndTarget,
                  f = t.arrowSize,
                  p = t.fitMaxHeightToBounds,
                  d = t.fitMaxWidthToBounds,
                  h = t.verticalPadding,
                  g = t.horizontalPadding,
                  w = t.avoidOverflowBounds,
                  y = t.contentHeight,
                  x = t.contentWidth,
                  P = t.containerWidth,
                  A =
                    o[0] +
                    O({
                      withArrow: i,
                      arrowSize: f,
                      spaceBetweenPopoverAndTarget: u,
                    }),
                  T = p ? n + o[1] - l : y,
                  S = d ? P - r - A - l : x;
                return {
                  style: (0, m.css)(
                    [
                      'left:',
                      'px;top:',
                      'px;',
                      '{max-height:',
                      'px;max-width:',
                      'px;}',
                    ],
                    d || !w ? r + A : Math.min(r + A, P - x - l),
                    p || !w ? n + o[1] : Math.max(n + o[1], y + l),
                    v,
                    T - h,
                    S - g
                  ),
                  initial: b(
                    b({}, a.initial),
                    {},
                    { x: '-'.concat(c, '%'), y: '-100%' }
                  ),
                  animate: b(b({}, a.animate), {}, { x: 0, y: '-100%' }),
                  exit: b(
                    b({}, a.exit),
                    {},
                    { x: '-'.concat(s, '%'), y: '-100%' }
                  ),
                };
              },
              rightTop: function (e, t) {
                var n = e.top,
                  r = e.right,
                  o = t.offset,
                  i = t.withArrow,
                  a = t.animation,
                  c = t.openingAnimationTranslateDistance,
                  s = t.closingAnimationTranslateDistance,
                  l = t.minSpaceBetweenPopoverAndContainer,
                  u = t.spaceBetweenPopoverAndTarget,
                  f = t.arrowSize,
                  p = t.fitMaxHeightToBounds,
                  d = t.fitMaxWidthToBounds,
                  h = t.verticalPadding,
                  g = t.horizontalPadding,
                  w = t.avoidOverflowBounds,
                  y = t.contentHeight,
                  x = t.contentWidth,
                  P = t.containerHeight,
                  A = t.containerWidth,
                  T =
                    o[0] +
                    O({
                      withArrow: i,
                      arrowSize: f,
                      spaceBetweenPopoverAndTarget: u,
                    }),
                  S = p ? P - (l + n + o[1]) : y,
                  B = d ? A - r - T - l : x;
                return {
                  style: (0, m.css)(
                    [
                      'left:',
                      'px;top:',
                      'px;',
                      '{max-height:',
                      'px;max-width:',
                      'px;min-width:',
                      'px;}',
                    ],
                    d || !w ? r + T : Math.min(r + T, A - x - l),
                    p || !w ? n + o[1] : Math.min(n + o[1], P - y - l),
                    v,
                    S - h,
                    B - g,
                    Math.min(B, x) - g
                  ),
                  initial: b(b({}, a.initial), {}, { x: '-'.concat(c, '%') }),
                  animate: b(b({}, a.animate), {}, { x: 0 }),
                  exit: b(b({}, a.exit), {}, { x: '-'.concat(s, '%') }),
                };
              },
            };
          function A(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function T(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          function S(e, t) {
            return (
              (function (e) {
                if (Array.isArray(e)) return e;
              })(e) ||
              (function (e, t) {
                if (
                  'undefined' != typeof Symbol &&
                  Symbol.iterator in Object(e)
                ) {
                  var n = [],
                    r = !0,
                    o = !1,
                    i = void 0;
                  try {
                    for (
                      var a, c = e[Symbol.iterator]();
                      !(r = (a = c.next()).done) &&
                      (n.push(a.value), !t || n.length !== t);
                      r = !0
                    );
                  } catch (e) {
                    (o = !0), (i = e);
                  } finally {
                    try {
                      r || null == c.return || c.return();
                    } finally {
                      if (o) throw i;
                    }
                  }
                  return n;
                }
              })(e, t) ||
              (function (e, t) {
                if (e) {
                  if ('string' == typeof e) return B(e, t);
                  var n = Object.prototype.toString.call(e).slice(8, -1);
                  return (
                    'Object' === n && e.constructor && (n = e.constructor.name),
                    'Map' === n || 'Set' === n
                      ? Array.from(e)
                      : 'Arguments' === n ||
                        /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
                      ? B(e, t)
                      : void 0
                  );
                }
              })(e, t) ||
              (function () {
                throw new TypeError(
                  'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
                );
              })()
            );
          }
          function B(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
            return r;
          }
          var C,
            M,
            j,
            z = function e(t) {
              return 'BODY' === t.tagName || t.scrollHeight > t.clientHeight
                ? t
                : e(t.parentElement);
            },
            D = function (e) {
              var t = e.triggerElementRef,
                n = e.placement,
                o = e.offset,
                i = e.withArrow,
                a = e.guessBetterPosition,
                c = e.animation,
                l = e.openingAnimationTranslateDistance,
                u = e.closingAnimationTranslateDistance,
                f = e.spaceBetweenPopoverAndTarget,
                p = e.getContainer,
                m = e.arrowSize,
                h = e.setBetterPlacement,
                g = e.canUpdate,
                w = e.minSpaceBetweenPopoverAndContainer,
                v = e.avoidOverflowBounds,
                y = e.fitMaxHeightToBounds,
                b = e.fitMaxWidthToBounds,
                x = e.maxHeight,
                O = e.maxWidth,
                B = e.isOpen,
                C = e.considerContentResizing,
                M = S((0, r.useState)({}), 2),
                j = M[0],
                D = M[1],
                W = (0, r.useRef)(),
                H = (0, r.useCallback)(
                  function () {
                    if (g && t.current && W.current) {
                      var e = p();
                      if (e) {
                        var r,
                          S =
                            'BODY' === (r = e).tagName
                              ? r
                              : ('static' ===
                                  window.getComputedStyle(r).position &&
                                  r.offsetParent) ||
                                r,
                          B = t.current.getBoundingClientRect(),
                          C = S.getBoundingClientRect(),
                          M = W.current,
                          j = M.height,
                          E = M.width,
                          H = (function (e, t) {
                            if (null == e) return {};
                            var n,
                              r,
                              o = (function (e, t) {
                                if (null == e) return {};
                                var n,
                                  r,
                                  o = {},
                                  i = Object.keys(e);
                                for (r = 0; r < i.length; r++)
                                  (n = i[r]),
                                    t.indexOf(n) >= 0 || (o[n] = e[n]);
                                return o;
                              })(e, t);
                            if (Object.getOwnPropertySymbols) {
                              var i = Object.getOwnPropertySymbols(e);
                              for (r = 0; r < i.length; r++)
                                (n = i[r]),
                                  t.indexOf(n) >= 0 ||
                                    (Object.prototype.propertyIsEnumerable.call(
                                      e,
                                      n
                                    ) &&
                                      (o[n] = e[n]));
                            }
                            return o;
                          })(M, ['height', 'width']),
                          k = {
                            bottom: B.bottom,
                            right: B.right,
                            top: B.top,
                            left: B.left,
                            width: B.width,
                            height: B.height,
                          },
                          R = n,
                          L = z(e),
                          I = L.scrollTop,
                          F = L.scrollLeft,
                          q = o;
                        if (a) {
                          var _ = e.getBoundingClientRect(),
                            N = _.top + I + j + f + w,
                            U = _.bottom - j - w - f,
                            $ = _.left + E + w + f,
                            Y = _.right - E - w - f;
                          if (
                            (['top', 'bottom'].includes(R)
                              ? k.right < $
                                ? (R = ''.concat(R, 'Left'))
                                : k.left > Y && (R = ''.concat(R, 'Right'))
                              : ['right', 'left'].includes(R) &&
                                (k.bottom < N
                                  ? (R = ''.concat(R, 'Top'))
                                  : k.top > U && (R = ''.concat(R, 'Bottom'))),
                            ['top', 'bottom'].some(function (e) {
                              return R.startsWith(e);
                            }))
                          )
                            for (var X = 0; X < 2; X++)
                              R = d(
                                R,
                                ['bottom', k.bottom, U],
                                ['top', k.top, N]
                              );
                          else
                            for (var G = 0; G < 2; G++)
                              R = d(
                                R,
                                ['top', k.top, U],
                                ['bottom', k.bottom, N]
                              );
                          if (
                            ['right', 'left'].some(function (e) {
                              return R.startsWith(e);
                            })
                          )
                            for (var J = 0; J < 2; J++)
                              R = d(
                                R,
                                ['right', k.right, Y],
                                ['left', k.left, $]
                              );
                          else
                            for (var K = 0; K < 2; K++)
                              R = d(
                                R,
                                ['left', k.left, Y],
                                ['right', k.right, $]
                              );
                          ['top', 'bottom'].some(function (e) {
                            return (
                              n.toLowerCase().indexOf(e) > -1 &&
                              -1 === R.toLowerCase().indexOf(e)
                            );
                          }) && (q[1] = 0),
                            ['left', 'right'].some(function (e) {
                              return (
                                n.toLowerCase().indexOf(e) > -1 &&
                                -1 === R.toLowerCase().indexOf(e)
                              );
                            }) && (q[0] = 0);
                        }
                        h(R),
                          (k.top -= C.top - I),
                          (k.bottom -= C.top - I),
                          (k.right -= C.left - F),
                          (k.left -= C.left - F),
                          D(
                            P[R](
                              k,
                              (function (e) {
                                for (var t = 1; t < arguments.length; t++) {
                                  var n =
                                    null != arguments[t] ? arguments[t] : {};
                                  t % 2
                                    ? A(Object(n), !0).forEach(function (t) {
                                        T(e, t, n[t]);
                                      })
                                    : Object.getOwnPropertyDescriptors
                                    ? Object.defineProperties(
                                        e,
                                        Object.getOwnPropertyDescriptors(n)
                                      )
                                    : A(Object(n)).forEach(function (t) {
                                        Object.defineProperty(
                                          e,
                                          t,
                                          Object.getOwnPropertyDescriptor(n, t)
                                        );
                                      });
                                }
                                return e;
                              })(
                                {
                                  offset: q,
                                  withArrow: i,
                                  animation: c,
                                  openingAnimationTranslateDistance: l,
                                  closingAnimationTranslateDistance: u,
                                  spaceBetweenPopoverAndTarget: f,
                                  arrowSize: m,
                                  minSpaceBetweenPopoverAndContainer: w,
                                  avoidOverflowBounds: v,
                                  fitMaxHeightToBounds: s().isBoolean(y)
                                    ? y
                                    : !x,
                                  fitMaxWidthToBounds: s().isBoolean(b)
                                    ? b
                                    : !O,
                                  contentHeight: j,
                                  contentWidth: E,
                                  containerWidth: C.width,
                                  containerHeight: C.height,
                                },
                                H
                              )
                            )
                          );
                      }
                    }
                  },
                  [t, a, o, n, W, i, c, l, u, f, p, m, g, h, w, y, b, x, O, v]
                ),
                k = S(
                  E({
                    onDimensionsChanged: H,
                    dimensionsRef: W,
                    isOpen: B,
                    considerContentResizing: C,
                  }),
                  2
                ),
                R = k[0];
              return {
                containerProps: j,
                updatePosition: H,
                contentRef: k[1],
                setContentDimensions: R,
                shouldCheckContentDimensions: !W.current,
              };
            },
            E = function (e) {
              var t = e.onDimensionsChanged,
                n = e.dimensionsRef,
                o = e.isOpen,
                i = e.considerContentResizing,
                a = (0, r.useRef)();
              return (
                (0, r.useLayoutEffect)(function () {
                  if (i && o && a.current && n.current) {
                    var e = a.current,
                      r = e.clientHeight,
                      c = e.clientWidth;
                    (n.current.height === r && n.current.width === c) ||
                      ((n.current.height = r), (n.current.width = c), t());
                  }
                }),
                [
                  (0, r.useCallback)(function (e) {
                    if (e) {
                      var t = e.clientHeight,
                        r = e.clientWidth,
                        o = e.firstChild;
                      n.current = {
                        height: t,
                        width: r,
                        verticalPadding: t - o.clientHeight,
                        horizontalPadding: r - o.clientWidth,
                      };
                    }
                  }, []),
                  a,
                ]
              );
            },
            W = {
              click: 'click',
              hover: 'hover',
              contextMenu: 'contextMenu',
              focus: 'focus',
            },
            H = 'horizontal',
            k = 'vertical',
            R = 'center',
            L = 'top',
            I = 'bottom',
            F = 'right',
            q = 'left';
          function _(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          var N =
              (_(
                (j = {}),
                k,
                (_((C = {}), R, function (e) {
                  var t = e.angle;
                  return (0,
                  m.css)(['top:50%;transform:translateY(-50%) rotate(', 'deg);'], t);
                }),
                _(C, L, function (e) {
                  var t = e.angle,
                    n = e.arrowOffset;
                  return (0,
                  m.css)(['top:', 'px;transform:rotate(', 'deg);'], n, t);
                }),
                _(C, I, function (e) {
                  var t = e.angle,
                    n = e.arrowOffset;
                  return (0,
                  m.css)(['bottom:', 'px;transform:rotate(', 'deg);'], n, t);
                }),
                C)
              ),
              _(
                j,
                H,
                (_((M = {}), R, function (e) {
                  var t = e.angle;
                  return (0,
                  m.css)(['left:50%;transform:translateX(-50%) rotate(', 'deg);'], t);
                }),
                _(M, F, function (e) {
                  var t = e.angle,
                    n = e.arrowOffset;
                  return (0,
                  m.css)(['right:', 'px;transform:rotate(', 'deg);'], n, t);
                }),
                _(M, q, function (e) {
                  var t = e.angle,
                    n = e.arrowOffset;
                  return (0,
                  m.css)(['left:', 'px;transform:rotate(', 'deg);'], n, t);
                }),
                M)
              ),
              j),
            U = function (e) {
              var t = e.type,
                n = e.angle,
                r = e.arrowPlacement,
                o = e.arrowOffset,
                i = e.defaultPlacement;
              return N[t][N[t][r] ? r : i]({ angle: n, arrowOffset: o });
            },
            $ = {
              top: function (e) {
                var t = e.arrowSize,
                  n = e.arrowPlacement,
                  r = e.arrowOffset;
                return (0, m.css)(
                  ['top:calc(100% - ', 'px);', ';'],
                  t / 2,
                  U({
                    type: H,
                    arrowPlacement: n,
                    arrowOffset: r,
                    defaultPlacement: R,
                    angle: -45,
                  })
                );
              },
              topRight: function (e) {
                var t = e.arrowSize,
                  n = e.arrowPlacement,
                  r = e.arrowOffset;
                return (0, m.css)(
                  ['top:calc(100% - ', 'px);', ';'],
                  t / 2,
                  U({
                    type: H,
                    arrowPlacement: n,
                    arrowOffset: r,
                    defaultPlacement: F,
                    angle: -45,
                  })
                );
              },
              topLeft: function (e) {
                var t = e.arrowSize,
                  n = e.arrowPlacement,
                  r = e.arrowOffset;
                return (0, m.css)(
                  ['top:calc(100% - ', 'px);', ';'],
                  t / 2,
                  U({
                    type: H,
                    arrowPlacement: n,
                    arrowOffset: r,
                    defaultPlacement: q,
                    angle: -45,
                  })
                );
              },
              bottom: function (e) {
                var t = e.arrowSize,
                  n = e.arrowPlacement,
                  r = e.arrowOffset;
                return (0, m.css)(
                  ['bottom:calc(100% - ', 'px);', ';'],
                  t / 2,
                  U({
                    type: H,
                    arrowPlacement: n,
                    arrowOffset: r,
                    defaultPlacement: R,
                    angle: 135,
                  })
                );
              },
              bottomRight: function (e) {
                var t = e.arrowSize,
                  n = e.arrowPlacement,
                  r = e.arrowOffset;
                return (0, m.css)(
                  ['bottom:calc(100% - ', 'px);', ';'],
                  t / 2,
                  U({
                    type: H,
                    arrowPlacement: n,
                    arrowOffset: r,
                    defaultPlacement: F,
                    angle: 135,
                  })
                );
              },
              bottomLeft: function (e) {
                var t = e.arrowSize,
                  n = e.arrowPlacement,
                  r = e.arrowOffset;
                return (0, m.css)(
                  ['bottom:calc(100% - ', 'px);', ';'],
                  t / 2,
                  U({
                    type: H,
                    arrowPlacement: n,
                    arrowOffset: r,
                    defaultPlacement: q,
                    angle: 135,
                  })
                );
              },
              left: function (e) {
                var t = e.arrowSize,
                  n = e.arrowPlacement,
                  r = e.arrowOffset;
                return (0, m.css)(
                  ['left:calc(100% - ', 'px);', ';'],
                  t / 2,
                  U({
                    type: k,
                    arrowPlacement: n,
                    arrowOffset: r,
                    defaultPlacement: R,
                    angle: -135,
                  })
                );
              },
              leftTop: function (e) {
                var t = e.arrowSize,
                  n = e.arrowPlacement,
                  r = e.arrowOffset;
                return (0, m.css)(
                  ['left:calc(100% - ', 'px);', ';'],
                  t / 2,
                  U({
                    type: k,
                    arrowPlacement: n,
                    arrowOffset: r,
                    defaultPlacement: L,
                    angle: -135,
                  })
                );
              },
              leftBottom: function (e) {
                var t = e.arrowSize,
                  n = e.arrowPlacement,
                  r = e.arrowOffset;
                return (0, m.css)(
                  ['left:calc(100% - ', 'px);', ';'],
                  t / 2,
                  U({
                    type: k,
                    arrowPlacement: n,
                    arrowOffset: r,
                    defaultPlacement: I,
                    angle: -135,
                  })
                );
              },
              right: function (e) {
                var t = e.arrowSize,
                  n = e.arrowPlacement,
                  r = e.arrowOffset;
                return (0, m.css)(
                  ['right:calc(100% - ', 'px);', ';'],
                  t / 2,
                  U({
                    type: k,
                    arrowPlacement: n,
                    arrowOffset: r,
                    defaultPlacement: R,
                    angle: 45,
                  })
                );
              },
              rightTop: function (e) {
                var t = e.arrowSize,
                  n = e.arrowPlacement,
                  r = e.arrowOffset;
                return (0, m.css)(
                  ['right:calc(100% - ', 'px);', ';'],
                  t / 2,
                  U({
                    type: k,
                    arrowPlacement: n,
                    arrowOffset: r,
                    defaultPlacement: L,
                    angle: 45,
                  })
                );
              },
              rightBottom: function (e) {
                var t = e.arrowSize,
                  n = e.arrowPlacement,
                  r = e.arrowOffset;
                return (0, m.css)(
                  ['right:calc(100% - ', 'px);', ';'],
                  t / 2,
                  U({
                    type: k,
                    arrowPlacement: n,
                    arrowOffset: r,
                    defaultPlacement: I,
                    angle: 45,
                  })
                );
              },
            },
            Y = function e(t) {
              return t
                ? t.scrollHeight > t.clientHeight
                  ? t
                  : e(t.parentNode)
                : window;
            },
            X = function (e) {
              var t = e.listener,
                n = (0, r.useRef)(),
                o = (0, r.useCallback)(
                  function () {
                    n.current && n.current.removeEventListener('scroll', t);
                  },
                  [t]
                );
              return (
                (0, r.useEffect)(
                  function () {
                    return o;
                  },
                  [o]
                ),
                (0, r.useCallback)(
                  function (e) {
                    o(),
                      (n.current = Y(e)),
                      n.current.addEventListener('scroll', t);
                  },
                  [t, o]
                )
              );
            };
          function G() {
            return (G =
              Object.assign ||
              function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = arguments[t];
                  for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
              }).apply(this, arguments);
          }
          function J(e, t) {
            return (
              (function (e) {
                if (Array.isArray(e)) return e;
              })(e) ||
              (function (e, t) {
                if (
                  'undefined' != typeof Symbol &&
                  Symbol.iterator in Object(e)
                ) {
                  var n = [],
                    r = !0,
                    o = !1,
                    i = void 0;
                  try {
                    for (
                      var a, c = e[Symbol.iterator]();
                      !(r = (a = c.next()).done) &&
                      (n.push(a.value), !t || n.length !== t);
                      r = !0
                    );
                  } catch (e) {
                    (o = !0), (i = e);
                  } finally {
                    try {
                      r || null == c.return || c.return();
                    } finally {
                      if (o) throw i;
                    }
                  }
                  return n;
                }
              })(e, t) ||
              (function (e, t) {
                if (e) {
                  if ('string' == typeof e) return K(e, t);
                  var n = Object.prototype.toString.call(e).slice(8, -1);
                  return (
                    'Object' === n && e.constructor && (n = e.constructor.name),
                    'Map' === n || 'Set' === n
                      ? Array.from(e)
                      : 'Arguments' === n ||
                        /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
                      ? K(e, t)
                      : void 0
                  );
                }
              })(e, t) ||
              (function () {
                throw new TypeError(
                  'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
                );
              })()
            );
          }
          function K(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
            return r;
          }
          function Q(e, t) {
            var n = e.children,
              i = e.content,
              a = e.placement,
              c = e.trigger,
              f = e.withArrow,
              p = e.offset,
              d = e.getContainer,
              m = e.isOpen,
              h = e.onChangeOpen,
              g = e.className,
              y = e.considerTriggerMotion,
              b = e.considerContentResizing,
              x = e.closeOnEscape,
              O = e.closeOnEnter,
              P = e.closeOnTab,
              A = e.closeOnScroll,
              T = e.closeOnRemoteClick,
              S = e.guessBetterPosition,
              B = e.onFocus,
              C = e.mouseEnterDelay,
              M = e.mouseLeaveDelay,
              j = e.triggerContainerDisplay,
              z = e.triggerContainerTag,
              E = e.maxHeight,
              H = e.maxWidth,
              k = e.minSpaceBetweenPopoverAndContainer,
              R = e.avoidOverflowBounds,
              L = e.fitMaxHeightToBounds,
              I = e.fitMaxWidthToBounds,
              F = e.animation,
              q = e.openingAnimationTranslateDistance,
              _ = e.closingAnimationTranslateDistance,
              N = e.spaceBetweenPopoverAndTarget,
              U = e.zIndex,
              Y = e.arrowSize,
              K = e.arrowOffset,
              Q = e.arrowPlacement,
              V = e.useTriggerWidth,
              Z = e.useTriggerHeight,
              ee = e.width,
              te = e.height,
              ne = e.usePortal,
              re = J((0, r.useState)(a), 2),
              oe = re[0],
              ie = re[1],
              ae = (function (e) {
                var t = e.closeOnEscape,
                  n = e.closeOnEnter,
                  o = e.closeOnTab,
                  i = e.closeOnRemoteClick,
                  a = e.isOpen,
                  c = e.onChangeOpen,
                  l = (0, r.useRef)({}),
                  u = (0, r.useRef)(document.body),
                  f = (0, r.useCallback)(function (e, t) {
                    l.current[e] = t;
                  }, []),
                  p = (0, r.useCallback)(
                    function (e) {
                      a !== e && c(e);
                    },
                    [c, a]
                  ),
                  d = (0, r.useCallback)(
                    function () {
                      p(!0);
                    },
                    [p]
                  ),
                  m = (0, r.useCallback)(
                    function () {
                      p(!1);
                    },
                    [p]
                  ),
                  h = (0, r.useCallback)(
                    function () {
                      p(!a);
                    },
                    [a, p]
                  );
                return (
                  (0, r.useEffect)(
                    function () {
                      if (a && i) {
                        var e = function (e) {
                          1 === (e.which || e.button) &&
                            a &&
                            ((u.current && !u.current.contains(e.target)) ||
                              s()
                                .values(l.current)
                                .filter(Boolean)
                                .find(function (t) {
                                  return t.contains(e.target);
                                }) ||
                              m());
                        };
                        return (
                          document.addEventListener('mousedown', e),
                          function () {
                            document.removeEventListener('mousedown', e);
                          }
                        );
                      }
                    },
                    [a, i, m]
                  ),
                  (0, r.useEffect)(
                    function () {
                      if (a && (t || n || o)) {
                        var e = function (e) {
                          a &&
                            [t && 'Escape', n && 'Enter', o && 'Tab'].includes(
                              e.key
                            ) &&
                            m();
                        };
                        return (
                          document.addEventListener('keydown', e),
                          function () {
                            document.removeEventListener('keydown', e);
                          }
                        );
                      }
                    },
                    [a, m, t, n, o]
                  ),
                  {
                    setOpen: p,
                    open: d,
                    close: m,
                    toggle: h,
                    addTarget: f,
                    parentNode: u,
                  }
                );
              })({
                closeOnRemoteClick: s().isBoolean(T) ? T : c !== W.hover,
                closeOnEscape: x,
                closeOnEnter: O,
                closeOnTab: P,
                isOpen: m,
                onChangeOpen: h,
              }),
              ce = ae.addTarget,
              se = ae.open,
              le = ae.close,
              ue = ae.toggle,
              fe = (0, r.useRef)(),
              pe = J((0, r.useState)({}), 2),
              de = pe[0],
              me = pe[1],
              he = (0, r.useCallback)(
                function () {
                  m && A && le();
                },
                [m, le, A]
              ),
              ge = X({ listener: he }),
              we = D({
                triggerElementRef: fe,
                placement: a,
                offset: p,
                withArrow: f,
                guessBetterPosition: S,
                animation: F,
                openingAnimationTranslateDistance: q,
                closingAnimationTranslateDistance: _,
                spaceBetweenPopoverAndTarget: N,
                getContainer: d,
                arrowSize: Y,
                setBetterPlacement: ie,
                canUpdate: ne,
                minSpaceBetweenPopoverAndContainer: k,
                avoidOverflowBounds: R,
                fitMaxHeightToBounds: L,
                fitMaxWidthToBounds: I,
                maxHeight: E,
                maxWidth: H,
                isOpen: m,
                considerContentResizing: b,
              }),
              ve = we.containerProps,
              ye = we.updatePosition,
              be = we.contentRef,
              xe = we.setContentDimensions,
              Oe = we.shouldCheckContentDimensions,
              Pe = (0, r.useCallback)(
                function (e) {
                  (be.current = e), ce('content', e);
                },
                [ce]
              );
            (0, r.useEffect)(
              function () {
                m && ye();
              },
              [a, m]
            );
            var Ae,
              Te,
              Se,
              Be,
              Ce,
              Me,
              je =
                ((Ae = ye),
                (Te = (0, r.useRef)()),
                (Se = (0, r.useRef)()),
                (Be = (0, r.useCallback)(
                  function () {
                    var e = Te.current.getBoundingClientRect(),
                      t = {
                        left: e.left,
                        right: e.right,
                        top: e.top,
                        bottom: e.bottom,
                        width: e.width,
                        height: e.height,
                      };
                    s().isEqual(Se.current, t) || ((Se.current = t), Ae());
                  },
                  [Ae]
                )),
                (Ce = (0, r.useMemo)(
                  function () {
                    return new window.MutationObserver(Be);
                  },
                  [Be]
                )),
                (Me = (0, r.useCallback)(
                  function (e) {
                    e &&
                      ((Te.current = e),
                      Ce.disconnect(),
                      Ce.observe(e, {
                        attributes: !0,
                        attributeFilter: ['style', 'class'],
                      }));
                  },
                  [Ce]
                )),
                (0, r.useEffect)(function () {
                  return function () {
                    Ce.disconnect();
                  };
                }, []),
                Me);
            !(function (e, t, n) {
              var o =
                  arguments.length > 3 && void 0 !== arguments[3]
                    ? arguments[3]
                    : 100,
                i = (0, r.useMemo)(
                  function () {
                    return s().debounce(t, o);
                  },
                  [t, o]
                );
              (0, r.useEffect)(
                function () {
                  if (n)
                    return (
                      window.addEventListener(e, i),
                      function () {
                        window.removeEventListener(e, i), i.cancel();
                      }
                    );
                },
                [e, i, n]
              );
            })('resize', ye, m);
            var ze = (function (e) {
                var t = e.isOpen,
                  n = e.open,
                  o = e.close,
                  i = e.toggle,
                  a = e.mouseEnterDelay,
                  c = e.mouseLeaveDelay,
                  l = e.onFocus,
                  u = (0, r.useMemo)(
                    function () {
                      return s().debounce(n, a);
                    },
                    [a, n]
                  ),
                  f = (0, r.useMemo)(
                    function () {
                      return s().debounce(o, c);
                    },
                    [c, o]
                  );
                (0, r.useEffect)(
                  function () {
                    return function () {
                      u.cancel(), f.cancel();
                    };
                  },
                  [u, f]
                );
                var p = (0, r.useCallback)(
                    function () {
                      t ? f.cancel() : u();
                    },
                    [f, t, u]
                  ),
                  d = (0, r.useCallback)(
                    function () {
                      u.cancel(), f();
                    },
                    [f, u]
                  ),
                  m = (0, r.useCallback)(
                    function (e) {
                      n(), l(e);
                    },
                    [l, n]
                  );
                return {
                  handleClick: (0, r.useCallback)(
                    function (e) {
                      e.preventDefault(), i();
                    },
                    [i]
                  ),
                  handleMouseEnter: p,
                  handleMouseLeave: d,
                  handleFocus: m,
                };
              })({
                isOpen: m,
                open: se,
                close: le,
                toggle: ue,
                mouseEnterDelay: C,
                mouseLeaveDelay: M,
                onFocus: B,
              }),
              De = ze.handleClick,
              Ee = ze.handleMouseEnter,
              We = ze.handleMouseLeave,
              He = ze.handleFocus,
              ke = (0, r.useCallback)(
                function (e) {
                  if (e && e.children.length) {
                    var n = e.children[0];
                    if ((ne && y && je(n), (fe.current = n), j))
                      e.style.display = j;
                    else {
                      var r = window.getComputedStyle(n);
                      e.style.display = r.display;
                    }
                  } else fe.current = e;
                  fe.current &&
                    me({
                      width: fe.current.offsetWidth,
                      height: fe.current.offsetHeight,
                    }),
                    ge(fe.current),
                    t && (s().isFunction(t) ? t(e) : (t.current = e)),
                    ce('trigger', e);
                },
                [t, y, j, je, ce, ne, ge]
              ),
              Re = (0, r.useMemo)(
                function () {
                  return s().fromPairs(
                    s().filter(
                      [
                        ['onMouseDown', c === W.click && De],
                        ['onMouseEnter', c === W.hover && Ee],
                        ['onMouseLeave', c === W.hover && We],
                        ['onContextMenu', c === W.contextMenu && De],
                      ],
                      1
                    )
                  );
                },
                [De, Ee, We, c]
              ),
              Le = (function (e) {
                var t = e.placement,
                  n = e.arrowSize,
                  o = e.arrowPlacement,
                  i = e.arrowOffset;
                return (0, r.useMemo)(
                  function () {
                    return $[t]({
                      arrowSize: n,
                      arrowPlacement: o,
                      arrowOffset: i,
                    });
                  },
                  [t, n, o, i]
                );
              })({
                placement: oe,
                arrowSize: Y,
                arrowPlacement: Q,
                arrowOffset: K,
              }),
              Ie = z,
              Fe = d(),
              qe = ne ? ve : F,
              _e = (0, r.useMemo)(
                function () {
                  return s().isFunction(i) ? i({ close: le }) : i;
                },
                [i, le]
              ),
              Ne = o().createElement(
                u.AnimatePresence,
                { initial: null },
                m &&
                  (!ne || ve.style) &&
                  o().createElement(
                    w,
                    {
                      ref: Pe,
                      withArrow: f,
                      arrowStyles: Le,
                      positionStyles: ve.style,
                      initial: qe.initial,
                      animate: qe.animate,
                      exit: qe.exit,
                      onMouseEnter: Re.onMouseEnter,
                      onMouseLeave: Re.onMouseLeave,
                      className: g,
                      zIndex: U,
                      arrowSize: Y,
                      width: V ? ''.concat(de.width, 'px') : ee,
                      height: Z ? ''.concat(de.height, 'px') : te,
                    },
                    o().createElement(v, { maxHeight: E, maxWidth: H }, _e)
                  )
              );
            return o().createElement(
              r.Fragment,
              null,
              Oe &&
                Fe &&
                (0, l.createPortal)(
                  o().createElement(
                    w,
                    {
                      ref: xe,
                      isCheckingContentDimensions: !0,
                      className: g,
                      width: V ? ''.concat(de.width, 'px') : ee,
                      height: Z ? ''.concat(de.height, 'px') : te,
                    },
                    o().createElement(v, { maxHeight: E, maxWidth: H }, _e)
                  ),
                  Fe
                ),
              ne ? Fe && (0, l.createPortal)(Ne, Fe) : Ne,
              c === W.focus
                ? o().cloneElement(
                    o().Children.only(
                      s().isFunction(n)
                        ? n({ isOpen: m, open: se, close: le, toggle: ue })
                        : n
                    ),
                    { onFocus: He, ref: ke }
                  )
                : o().createElement(
                    Ie,
                    G({}, Re, { ref: ke }),
                    s().isFunction(n)
                      ? n({ isOpen: m, open: se, close: le, toggle: ue })
                      : n
                  )
            );
          }
          var V = o().forwardRef(Q);
          (V.propTypes = {
            placement: a().oneOf(Object.keys(P)),
            trigger: a().oneOf(Object.keys(W)),
            onFocus: a().func,
            withArrow: a().bool,
            children: a().any,
            content: a().any.isRequired,
            offset: a().arrayOf(a().number),
            getContainer: a().func,
            isOpen: a().bool,
            onChangeOpen: a().func,
            className: a().string,
            considerTriggerMotion: a().bool,
            considerContentResizing: a().bool,
            closeOnEscape: a().bool,
            closeOnEnter: a().bool,
            closeOnTab: a().bool,
            closeOnScroll: a().bool,
            closeOnRemoteClick: a().bool,
            guessBetterPosition: a().bool,
            mouseEnterDelay: a().number,
            mouseLeaveDelay: a().number,
            triggerContainerDisplay: a().string,
            triggerContainerTag: a().string,
            animation: a().shape({
              initial: a().object,
              animate: a().object,
              exit: a().object,
            }),
            openingAnimationTranslateDistance: a().number,
            closingAnimationTranslateDistance: a().number,
            zIndex: a().number,
            spaceBetweenPopoverAndTarget: a().number,
            arrowSize: a().number,
            arrowOffset: a().number,
            arrowPlacement: a().string,
            maxWidth: a().string,
            maxHeight: a().string,
            minSpaceBetweenPopoverAndContainer: a().number,
            fitMaxWidthToBounds: a().bool,
            fitMaxHeightToBounds: a().bool,
            avoidOverflowBounds: a().bool,
            width: a().string,
            height: a().string,
            useTriggerWidth: a().bool,
            useTriggerHeight: a().bool,
            usePortal: a().bool,
          }),
            (V.defaultProps = {
              placement: 'top',
              trigger: W.hover,
              withArrow: !0,
              offset: [0, 0],
              onChangeOpen: s().noop,
              considerTriggerMotion: !1,
              closeOnEscape: !0,
              closeOnEnter: !1,
              closeOnTab: !1,
              closeOnScroll: !0,
              getContainer: function () {
                return document.body;
              },
              guessBetterPosition: !1,
              mouseEnterDelay: 100,
              mouseLeaveDelay: 100,
              onFocus: s().noop,
              triggerContainerTag: 'span',
              animation: {
                initial: { opacity: 0, scale: 0.9 },
                animate: { opacity: 1, scale: 1 },
                exit: { opacity: 0, scale: 0.9, transition: { duration: 0.1 } },
              },
              openingAnimationTranslateDistance: 30,
              closingAnimationTranslateDistance: 0,
              minSpaceBetweenPopoverAndContainer: 10,
              spaceBetweenPopoverAndTarget: 7,
              arrowSize: 8,
              arrowOffset: 10,
              useTriggerWidth: !1,
              useTriggerHeight: !1,
              width: 'unset',
              height: 'unset',
              usePortal: !0,
              avoidOverflowBounds: !0,
              considerContentResizing: !1,
            });
          var Z = V;
          function ee(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function te(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? ee(Object(n), !0).forEach(function (t) {
                    ne(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : ee(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function ne(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          function re() {
            return (re =
              Object.assign ||
              function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = arguments[t];
                  for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
              }).apply(this, arguments);
          }
          function oe(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
            return r;
          }
          function ie(e, t) {
            var n,
              i,
              a = e.isOpen,
              c = e.onChangeOpen,
              l = e.triggerContainerTag,
              u = e.children,
              f = e.trigger,
              p = e.triggerContainerDisplay,
              d = e.mouseEnterDelay,
              m =
                ((n = (0, r.useState)(function () {
                  return a || s().isFunction(u) || f === W.focus;
                })),
                (i = 2),
                (function (e) {
                  if (Array.isArray(e)) return e;
                })(n) ||
                  (function (e, t) {
                    if (
                      'undefined' != typeof Symbol &&
                      Symbol.iterator in Object(e)
                    ) {
                      var n = [],
                        r = !0,
                        o = !1,
                        i = void 0;
                      try {
                        for (
                          var a, c = e[Symbol.iterator]();
                          !(r = (a = c.next()).done) &&
                          (n.push(a.value), !t || n.length !== t);
                          r = !0
                        );
                      } catch (e) {
                        (o = !0), (i = e);
                      } finally {
                        try {
                          r || null == c.return || c.return();
                        } finally {
                          if (o) throw i;
                        }
                      }
                      return n;
                    }
                  })(n, i) ||
                  (function (e, t) {
                    if (e) {
                      if ('string' == typeof e) return oe(e, t);
                      var n = Object.prototype.toString.call(e).slice(8, -1);
                      return (
                        'Object' === n &&
                          e.constructor &&
                          (n = e.constructor.name),
                        'Map' === n || 'Set' === n
                          ? Array.from(e)
                          : 'Arguments' === n ||
                            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
                          ? oe(e, t)
                          : void 0
                      );
                    }
                  })(n, i) ||
                  (function () {
                    throw new TypeError(
                      'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
                    );
                  })()),
              h = m[0],
              g = m[1],
              w = (0, r.useCallback)(
                function () {
                  c(!0);
                },
                [c]
              );
            return (
              (0, r.useEffect)(
                function () {
                  a && g(!0);
                },
                [a]
              ),
              h
                ? o().createElement(
                    Z,
                    re({}, e, { ref: t, isOpen: a, onChangeOpen: c }),
                    u
                  )
                : o().createElement(
                    ce,
                    {
                      triggerContainerTag: l,
                      trigger: f,
                      triggerContainerDisplay: p,
                      initialize: w,
                      mouseEnterDelay: d,
                      ref: t,
                    },
                    u
                  )
            );
          }
          function ae(e, t) {
            var n = e.triggerContainerTag,
              i = e.children,
              a = e.trigger,
              c = e.triggerContainerDisplay,
              l = e.initialize,
              u = e.mouseEnterDelay,
              f = (0, r.useCallback)(
                function (e) {
                  if (e && e.children.length) {
                    var n = e.children[0];
                    if (c) e.style.display = c;
                    else {
                      var r = window.getComputedStyle(n);
                      e.style.display = r.display;
                    }
                  }
                  t && (s().isFunction(t) ? t(e) : (t.current = e));
                },
                [c, t]
              ),
              p = n,
              d = (0, r.useMemo)(
                function () {
                  return s().debounce(l, u);
                },
                [l, u]
              );
            (0, r.useEffect)(
              function () {
                return function () {
                  d.cancel();
                };
              },
              [d]
            );
            var m = (0, r.useMemo)(
              function () {
                return a === W.hover
                  ? { onMouseEnter: d, onMouseLeave: d.cancel }
                  : ne({}, 'on'.concat(s().upperFirst(a)), l);
              },
              [d, l, a]
            );
            return a === W.focus
              ? o().cloneElement(
                  o().Children.only(i),
                  te(te({}, m), {}, { ref: f })
                )
              : o().createElement(p, re({}, m, { ref: f }), i);
          }
          var ce = o().forwardRef(ae),
            se = o().forwardRef(ie);
          (se.propTypes = Z.propTypes), (se.defaultProps = Z.defaultProps);
          var le = se;
          function ue() {
            return (ue =
              Object.assign ||
              function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = arguments[t];
                  for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
              }).apply(this, arguments);
          }
          function fe(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
            return r;
          }
          function pe(e, t) {
            var n,
              i,
              a = e.initialIsOpen,
              c = e.isOpen,
              l = e.onChangeOpen,
              u = (function (e, t) {
                if (null == e) return {};
                var n,
                  r,
                  o = (function (e, t) {
                    if (null == e) return {};
                    var n,
                      r,
                      o = {},
                      i = Object.keys(e);
                    for (r = 0; r < i.length; r++)
                      (n = i[r]), t.indexOf(n) >= 0 || (o[n] = e[n]);
                    return o;
                  })(e, t);
                if (Object.getOwnPropertySymbols) {
                  var i = Object.getOwnPropertySymbols(e);
                  for (r = 0; r < i.length; r++)
                    (n = i[r]),
                      t.indexOf(n) >= 0 ||
                        (Object.prototype.propertyIsEnumerable.call(e, n) &&
                          (o[n] = e[n]));
                }
                return o;
              })(e, ['initialIsOpen', 'isOpen', 'onChangeOpen']),
              f =
                ((n = (0, r.useState)(a)),
                (i = 2),
                (function (e) {
                  if (Array.isArray(e)) return e;
                })(n) ||
                  (function (e, t) {
                    if (
                      'undefined' != typeof Symbol &&
                      Symbol.iterator in Object(e)
                    ) {
                      var n = [],
                        r = !0,
                        o = !1,
                        i = void 0;
                      try {
                        for (
                          var a, c = e[Symbol.iterator]();
                          !(r = (a = c.next()).done) &&
                          (n.push(a.value), !t || n.length !== t);
                          r = !0
                        );
                      } catch (e) {
                        (o = !0), (i = e);
                      } finally {
                        try {
                          r || null == c.return || c.return();
                        } finally {
                          if (o) throw i;
                        }
                      }
                      return n;
                    }
                  })(n, i) ||
                  (function (e, t) {
                    if (e) {
                      if ('string' == typeof e) return fe(e, t);
                      var n = Object.prototype.toString.call(e).slice(8, -1);
                      return (
                        'Object' === n &&
                          e.constructor &&
                          (n = e.constructor.name),
                        'Map' === n || 'Set' === n
                          ? Array.from(e)
                          : 'Arguments' === n ||
                            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
                          ? fe(e, t)
                          : void 0
                      );
                    }
                  })(n, i) ||
                  (function () {
                    throw new TypeError(
                      'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
                    );
                  })()),
              p = f[0],
              d = f[1],
              m = (0, r.useMemo)(
                function () {
                  return !s().isUndefined(c);
                },
                [c]
              ),
              h = (0, r.useCallback)(
                function (e) {
                  l(e), m || d(e);
                },
                [m, l]
              ),
              g = { isOpen: m ? c : p, onChangeOpen: h };
            return u.lazy
              ? o().createElement(le, ue({ ref: t }, g, u))
              : o().createElement(Z, ue({ ref: t }, g, u));
          }
          var de = o().forwardRef(pe);
          (de.propTypes = {
            lazy: a().bool,
            initialIsOpen: a().bool,
            isOpen: a().bool,
            onChangeOpen: a().func,
          }),
            (de.defaultProps = {
              lazy: !0,
              initialIsOpen: !1,
              onChangeOpen: s().noop,
            });
          var me = de;
          function he() {
            return (he =
              Object.assign ||
              function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = arguments[t];
                  for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
              }).apply(this, arguments);
          }
          function ge(e) {
            var t = e.title,
              n = e.children,
              r = (function (e, t) {
                if (null == e) return {};
                var n,
                  r,
                  o = (function (e, t) {
                    if (null == e) return {};
                    var n,
                      r,
                      o = {},
                      i = Object.keys(e);
                    for (r = 0; r < i.length; r++)
                      (n = i[r]), t.indexOf(n) >= 0 || (o[n] = e[n]);
                    return o;
                  })(e, t);
                if (Object.getOwnPropertySymbols) {
                  var i = Object.getOwnPropertySymbols(e);
                  for (r = 0; r < i.length; r++)
                    (n = i[r]),
                      t.indexOf(n) >= 0 ||
                        (Object.prototype.propertyIsEnumerable.call(e, n) &&
                          (o[n] = e[n]));
                }
                return o;
              })(e, ['title', 'children']);
            return o().createElement(me, he({ content: t }, r), n);
          }
          ge.propTypes = { title: a().string, children: a().any };
          var we = ge;
        },
        762: function (e) {
          e.exports = o;
        },
        804: function (e) {
          e.exports = n;
        },
        229: function (e) {
          e.exports = t;
        },
        297: function (t) {
          t.exports = e;
        },
        268: function (e) {
          e.exports = r;
        },
        914: function (e) {
          e.exports = i;
        },
        849: function (e) {
          e.exports = a;
        },
      },
      s = {};
    function l(e) {
      if (s[e]) return s[e].exports;
      var t = (s[e] = { exports: {} });
      return c[e](t, t.exports, l), t.exports;
    }
    return (
      (l.n = function (e) {
        var t =
          e && e.__esModule
            ? function () {
                return e.default;
              }
            : function () {
                return e;
              };
        return l.d(t, { a: t }), t;
      }),
      (l.d = function (e, t) {
        for (var n in t)
          l.o(t, n) &&
            !l.o(e, n) &&
            Object.defineProperty(e, n, { enumerable: !0, get: t[n] });
      }),
      (l.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }),
      (l.r = function (e) {
        'undefined' != typeof Symbol &&
          Symbol.toStringTag &&
          Object.defineProperty(e, Symbol.toStringTag, { value: 'Module' }),
          Object.defineProperty(e, '__esModule', { value: !0 });
      }),
      l(641)
    );
  })();
});
